/**
 * Utility function to translate payment types from backend values to Italian display names
 * @param {string} paymentType - The payment type from backend (cash, stripe, bank_transfer)
 * @returns {string} - The Italian translation for the payment type
 */
export const translatePaymentType = (paymentType) => {
  switch (paymentType) {
    case 'cash':
      return 'Contanti';
    case 'stripe':
      return 'Stripe';
    case 'bank_transfer':
      return 'Bonifico';
    default:
      return paymentType || 'N/A';
  }
};

/**
 * Utility function to get the color for payment type chips
 * @param {string} paymentType - The payment type from backend
 * @returns {string} - The color for the chip
 */
export const getPaymentTypeColor = (paymentType) => {
  switch (paymentType) {
    case 'stripe':
      return 'success';
    case 'cash':
      return 'info';
    case 'bank_transfer':
      return 'warning';
    default:
      return 'default';
  }
}; 